module.exports = __webpack_public_path__ + "static/media/newloader.69ec2b90.gif";